module.exports = "/cabinet/img/header-logo.282eb273.svg";